import { render, staticRenderFns } from "./ai-domain-card.vue?vue&type=template&id=19417b86&scoped=true&"
import script from "./ai-domain-card.ts?vue&type=script&lang=ts&"
export * from "./ai-domain-card.ts?vue&type=script&lang=ts&"
import style0 from "./ai-domain-card.scss?vue&type=style&index=0&id=19417b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19417b86",
  null
  
)

export default component.exports